import React, { Component } from 'react';

export default class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {busy: false}
        this.handleLogoutButton = this.handleLogoutButton.bind(this);
    }

    async handleLogoutButton(event) {
        event.preventDefault();
        this.setState({busy:true});
        try {
            await this.props.onLogOut();
        } finally {
            this.setState({busy:false});
        }
    }

    render() {
        const text = this.state.busy ? 'Logging out…' : 'Log out';
        return <button className="log-out-button" type="button" onClick={this.handleLogoutButton}>{text}</button>;
    }
}



// WEBPACK FOOTER //
// ./src/ui/Logout.jsx